var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13393 0.189846L0.189065 1.14168C0.0628892 1.26851 0 1.41462 0 1.57979C0 1.74457 0.0628892 1.8906 0.189065 2.01744L7.61682 9.4999L0.189264 16.982C0.063088 17.1089 0.000198489 17.255 0.000198489 17.4199C0.000198489 17.585 0.063088 17.731 0.189264 17.8578L1.13419 18.8096C1.2601 18.9367 1.40508 19 1.56892 19C1.73263 19 1.87761 18.9365 2.00352 18.8096L10.8111 9.93781C10.937 9.81098 11 9.66487 11 9.4999C11 9.33492 10.937 9.18909 10.8111 9.06232L2.00352 0.189846C1.87754 0.0630131 1.73257 0 1.56892 0C1.40508 0 1.2601 0.0630131 1.13393 0.189846Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1339 0.189846L9.18907 1.14168C9.06289 1.26851 9 1.41462 9 1.57979C9 1.74457 9.06289 1.8906 9.18907 2.01744L16.6168 9.4999L9.18926 16.982C9.06309 17.1089 9.0002 17.255 9.0002 17.4199C9.0002 17.585 9.06309 17.731 9.18926 17.8578L10.1342 18.8096C10.2601 18.9367 10.4051 19 10.5689 19C10.7326 19 10.8776 18.9365 11.0035 18.8096L19.8111 9.93781C19.937 9.81098 20 9.66487 20 9.4999C20 9.33492 19.937 9.18909 19.8111 9.06232L11.0035 0.189846C10.8775 0.0630131 10.7326 0 10.5689 0C10.4051 0 10.2601 0.0630131 10.1339 0.189846Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.ba28dfeba6ad70c067ebe7b61ee0a094.svg";
export { ForwardRef as ReactComponent };